import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';

function getColumnVisibilityMenuOption(_ref) {
  var columns = _ref.columns,
      onColumnVisibilityChange = _ref.onColumnVisibilityChange,
      searchable = _ref.searchable,
      height = _ref.height;

  var _columns$reduce = columns.reduce(function (result, column, index) {
    return {
      items: [].concat(_toConsumableArray(result.items), [{
        id: column.property,
        label: column.label,
        checked: column.visible,
        onClick: function onClick() {
          return onColumnVisibilityChange(column, index);
        }
      }]),
      active: !column.visible ? result.active : [].concat(_toConsumableArray(result.active), [column.property])
    };
  }, {
    items: [],
    active: []
  }),
      items = _columns$reduce.items,
      active = _columns$reduce.active;

  return {
    type: 'SelectionGroup',
    id: 'column-visibility-option',
    multi: true,
    searchable: searchable,
    closeOnClick: false,
    active: active,
    items: items,
    height: height
  };
}

export { getColumnVisibilityMenuOption };
//# sourceMappingURL=ColumnVisibilityMenuOption.js.map
